import Skeleton from '@trackman/web-shared-components/components/LoadingPlaceholder/Skeleton';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: 15px;
  display: flex;
  gap: 40px;
`;

export const SettingsSkeleton = () => {
  return (
    <Wrapper>
      <Skeleton variant='rectangular' width={104} height={32} />
    </Wrapper>
  );
};
